import React from 'react';
import { formatPrintDate, formatSite, MetadataGrid, PrintFooter, PrintHeader, SectionBar, text } from './PrintRecordParts';

const RESULTS = { P: 'PASS', F: 'FAIL', N: 'N/A' };

export default function PrintOperatorChecklist({ header = {}, sections = [], pfn = {} }) {
  let sequence = 0;
  const prepared = sections.map((section, sectionIndex) => ({
    ...section,
    sectionNumber: String(section.title || '').match(/^\s*(\d+)/)?.[1] || String(sectionIndex + 1),
    sectionTitle: String(section.title || '').replace(/^\s*\d+[.)]?\s*/, ''),
    items: (section.items || []).map((item) => ({ item, sequence: ++sequence })),
  }));
  const renderSection = (section) => (
    <section className="print-checklist-section" key={section.title} data-section={section.sectionNumber}>
      <SectionBar>{section.sectionNumber} · {section.sectionTitle}</SectionBar>
      {section.items.map(({ item, sequence: itemNumber }) => {
        const label = typeof item === 'string' ? item : item?.label || '';
        const key = typeof item === 'string' ? `check_${item}` : item?.key || `check_${label}`;
        const selected = pfn[key];
        return <div className="checklist-print-row" key={key} data-item-number={itemNumber}>
          <span className="print-item-number">{itemNumber}</span>
          <span className="checklist-print-item">{label}</span>
          <span className={`checklist-print-result print-result print-result-${selected === 'N' ? 'na' : String(selected || '').toLowerCase()}`}>{RESULTS[selected] || ''}</span>
        </div>;
      })}
    </section>
  );
  const recordId = text(header.recordId);
  const title = 'Operator Pre-Shift Checklist';
  return <div className="ocf-wrap print-record print-only">
    <PrintHeader title={title} recordId={recordId} timestamp={header.submittedAt || header.date} />
    <MetadataGrid cells={[
      { label: 'Customer', value: header.customerName },
      { label: 'Site', value: formatSite(header), wide: true },
      { label: 'Unit ID', value: header.unitId },
      { label: 'Hour Meter', value: header.hourMeter },
      { label: 'Make / Model', value: [header.make, header.model].filter(Boolean).join(' / ') },
      { label: 'Serial Number', value: header.serialNumber },
      { label: 'Operator', value: header.performedByName || header.operatorName },
      { label: 'Completed', value: formatPrintDate(header.submittedAt || header.date, Boolean(header.submittedAt)) },
    ]} />
    <div className="operator-section-columns">
      <div className="print-section-column" data-column="left">{prepared.slice(0, 2).map(renderSection)}</div>
      <div className="print-section-column" data-column="right">{prepared.slice(2, 4).map(renderSection)}</div>
    </div>
    <div className="print-closing-grid">
      <section className="print-closing-block"><SectionBar>Notes / Comments</SectionBar><div className="print-closing-body">{text(header.notes)}</div></section>
      <section className="print-closing-block"><SectionBar>Signed By</SectionBar><div className="print-closing-body print-signature">{text(header.operatorSignature)}{header.performedByName && <small>{header.performedByName}</small>}</div></section>
    </div>
    <PrintFooter title={title} />
  </div>;
}
